import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"


export const PROPERTY = "preferences.driverCommentTitle"

export const schema = Validation.string()


const DriverCommentTitle = ({survey, onChange, required, label, ...props}) => {
  return (
    <Input
      name={PROPERTY}
      type="text"
      value={get(survey, PROPERTY)}
      onChange={(value) => onChange(survey, PROPERTY, value)}
      label={`${label}${required ? "*" : ""}`}
      {...props}
      id={id(PROPERTY, props)} />
  )
}

DriverCommentTitle.propTypes = {
  survey: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  validation: PropTypes.object
}

DriverCommentTitle.defaultProps = {
  required: false,
  placeholder: "Open feedback title",
  label: "Open feedback title",
  hint: "This is optional, a default will be set if this is left blank",
  validation: schema
}

export default DriverCommentTitle
